// extracted by mini-css-extract-plugin
export var addViewLink = "_1b-1";
export var availabilityIcon = "_1b-16";
export var availabilitySelectionIcon = "_1b-15";
export var backButton = "_1b-2";
export var backIcon = "_1b-z";
export var conversationCount = "_1b-3";
export var dragHandle = "_1b-5";
export var dropdown = "_1b-e";
export var dropdownIcon = "_1b-7";
export var dropdownOption = "_1b-6";
export var dropdownTriangle = "_1b-d";
export var expand = "_1b-f";
export var folder = "_1b-i";
export var folderItem = "_1b-c";
export var icon = "_1b-8";
export var iconRow = "_1b-9";
export var image = "_1b-a";
export var logo = "_1b-b";
export var navContainer = "_1b-h";
export var navigationFooter = "_1b-g";
export var pageShell = "_1b-0";
export var placeholderAvailable = "_1b-11";
export var placeholderBox = "_1b-14";
export var placeholderBusy = "_1b-13";
export var placeholderUnavailable = "_1b-12";
export var profile = "_1b-k";
export var profileContainer = "_1b-m";
export var profileDropdown = "_1b-n";
export var profileImage = "_1b-l";
export var profileMain = "_1b-o";
export var profileSubtitle = "_1b-q";
export var profileTitle = "_1b-p";
export var reorderIcon = "_1b-r";
export var sentLine = "_1b-u";
export var settingsHeader = "_1b-s";
export var sidenavTextColor = "_1b-y";
export var spamLine = "_1b-t";
export var subitemWithTag = "_1b-4";
export var supportItems = "_1b-j";
export var teamText = "_1b-10";
export var viewLine = "_1b-x";
export var viewLineButton = "_1b-w";
export var viewLineButtons = "_1b-v";